import { render, staticRenderFns } from "./CenteredColumn.vue?vue&type=template&id=4b729ac0"
import script from "./CenteredColumn.vue?vue&type=script&lang=js"
export * from "./CenteredColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b729ac0')) {
      api.createRecord('4b729ac0', component.options)
    } else {
      api.reload('4b729ac0', component.options)
    }
    module.hot.accept("./CenteredColumn.vue?vue&type=template&id=4b729ac0", function () {
      api.rerender('4b729ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/CenteredColumn.vue"
export default component.exports